import { FETCH_STOP, FETCH_START } from '../types';
import { createAction } from '@reduxjs/toolkit';

export const fetchStart = createAction<boolean, typeof FETCH_START>(
  FETCH_START,
);
export const fetchStop = createAction<boolean, typeof FETCH_STOP>(FETCH_STOP);
